//jscs:disable requireCamelCaseOrUpperCaseIdentifiers

import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import IconSVG from 'svg-inline-react';
import {
    getAddressHintsDelay,
    getLocationFromGoogleByQuery,
    getLocationFromGoogleByCords,
    getImgStaticMapGoogleByCords,
} from 'api';
import { find } from 'lodash';
import ActionCreators from 'actions/ActionCreators';
import SuggestControl from 'components/SuggestControl';
import SelectControl from 'components/SelectControl';
import FlagControl from 'components/FlagControl';
import GoogleWaypointMapDialog from 'components/GoogleWaypointMapDialog';
import transformGoogleGeocodedData from '../../../tools/transform-google-geocoded-data';
import transformTwoGisGeocodedData from '../../../tools/transform-2gis-geocoded-data';
import { cancelablePromise } from 'core/utils';
import isWebview from 'is-webview';
import AnimakitExpander from 'animakit-expander';
const countriesConfig = require('../../../configs/countries.config.json');

import './AddressControl.scss';

const GEOLOCATION_TIMEOUT = 5000;

class AddressControl extends Component {

    static propTypes = {
        address: PropTypes.object,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        iso: PropTypes.string,
        countries: PropTypes.array.isRequired,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        show: PropTypes.bool,
        onMapSave: PropTypes.func,
        presetLocation: PropTypes.bool,
        highlightInput: PropTypes.bool,
        defaultCountry: PropTypes.number,
    }

    static defaultProps = {
        label: 'Метка',
        show: true,
        presetLocation: false,
        highlightInput: false,
    }

    state = {
        suggestions: [],
        showMap: false,
        imgSrc: '',
    }

    RUSSIA_COUNTRY_ID = 1;

    isSuggestSelected = false;
    isMapLocationSelected = false;
    getDadataPromise = null;
    addressInputDOMnode = null;

    componentDidMount() {
        if (this.addressInputDOMnode && this.props.highlightInput) {
            this.addressInputDOMnode.focus();
        }

        if (this.props.address && this.props.address.coords) {
            this._fetchStaticMap();
        }
    }

    componentWillUnmount() {

        // Cancel request promises
        this.getDadataPromise && typeof this.getDadataPromise.cancel === 'function' ? this.getDadataPromise.cancel() : false;
    }

    _getFromDadata(query) {
        const countryId = parseInt(this.props.address.country);
        let provider;

        if (countryId === this.RUSSIA_COUNTRY_ID) {
            provider = '2gis';
        } else {
            provider = 'google';
        }

        this.getDadataPromise = cancelablePromise(getAddressHintsDelay(query, this.props.address.country, provider))

        this.getDadataPromise
            .promise
            .then(response_data => this.setState({ suggestions: response_data.response }))
            .catch(error => {});
    }

    async _fetchStaticMap() {
        const { address } = this.props;

        if (address.coords) {
            const imgSrc = await getImgStaticMapGoogleByCords(address.coords[1], address.coords[0]);

            this.setState({ imgSrc });
        }
    }

    _getGeolocation() {

        // Dew to some mobile platform factor the user don't see the permission request for
        // geolocation and booking looks like not responding
        if (isWebview(navigator.userAgent) || navigator.userAgent === 'Android') {
            return false;
        }

        this.setState({
            suggestions: [{
                city_full: '',
                rendered_suggestion:
                    (
                        <div className="AddressControl-geo">
                            <IconSVG className="AddressControl-geoIcon" src={require('!svg-inline!./goal.svg')}/>
                            Текущее местоположение
                        </div>
                    )
            }],
        });
    }

    _getSuggestions = (query) => {
        this.isSuggestSelected = false;
        this.isMapLocationSelected = false;
        query = query.value;

        if (!query) {
            this._getGeolocation();
        } else {
            this._getFromDadata(query);
        }
    }

    _suggestionRenderer = (suggestion) => {
        if (!suggestion) {
            return '';
        }

        return suggestion.rendered_suggestion || suggestion.city_full;
    }

    _suggestionValue = (suggestion) => {
        if (!suggestion) {
            return '';
        }
        return suggestion.city_full;
    }

    _saveReadySuggestion = (suggestion) => {
        var location = suggestion;

        location.city = suggestion.city;
        location.city_full = suggestion.city_full;
        location.text = suggestion.city_full;
        location.need_calibration = false;

        if (this.props.onChange) {
            this.props.onChange.call(null, location);
        }

        if (this.props.onBlur) {
            this.props.onBlur.call(null);
        }
    }

    _saveGeoDataSuggestion = (suggestion, geocodedData) => {
        suggestion.coords = [geocodedData.coords.lon || geocodedData.coords.lng, geocodedData.coords.lat];
        suggestion.city_full = geocodedData.formatted_address;
        suggestion.country = geocodedData.country;
        suggestion.country_name = geocodedData.country_name;
        suggestion.country_iso = geocodedData.country_iso;
        suggestion.region = geocodedData.region;
        suggestion.area = geocodedData.area;
        suggestion.city = geocodedData.city;
        suggestion.street = geocodedData.street;
        suggestion.home = geocodedData.street_number;
        suggestion.postal_code = geocodedData.postal_code;
    }


    _geolocationErrorHandler = (hide_overlay = true) => {
        if (hide_overlay) {
            ActionCreators.hideLoadingOverlay();
        }
        alert('Ваше местоположение определить не удалось');
    }

    _onSuggestionSelected = (event, { suggestion }) => {
        this.isSuggestSelected = true;
        if (!suggestion)
            return false;

        // If user wants to detect his geolocation
        if (!suggestion.city_full) {
            if ('geolocation' in navigator) {
                let provider;

                ActionCreators.showLoadingOverlay();

                if (this.props.address.country === this.RUSSIA_COUNTRY_ID) {
                    provider = '2gis';
                } else {
                    provider = 'google';
                }

                navigator.geolocation.getCurrentPosition((position) => {
                    getLocationFromGoogleByCords(position.coords.latitude, position.coords.longitude, provider)
                        .then(
                            async (done) => {
                                let resultItems;

                                if (provider === '2gis' && !done.isBrokenAddressTwoGis) {
                                    resultItems = done.result.items;
                                } else {
                                    resultItems = done.results;
                                }

                                ActionCreators.hideLoadingOverlay();

                                if (!resultItems)
                                    return false;

                                if (resultItems[0]) {
                                    let resultItem = resultItems[0];
                                    let geocodedData;

                                    if (provider === '2gis' && !done.isBrokenAddressTwoGis) {
                                        geocodedData = await transformTwoGisGeocodedData(resultItem);
                                    } else {
                                        geocodedData = await transformGoogleGeocodedData(resultItem);
                                    }

                                    this._saveGeoDataSuggestion(suggestion, geocodedData);
                                }
                                this._saveReadySuggestion(suggestion);

                                await this._fetchStaticMap();
                            },
                            this._geolocationErrorHandler
                        );
                }, this._geolocationErrorHandler, {
                    timeout: GEOLOCATION_TIMEOUT
                });
            } else {
                // Geolocation IS NOT available. May be detect by IP with help of dadata.ru? Hmmm...
            }
        } else {
            let provider;

            if (suggestion.country_name === 'Россия') {
                provider = '2gis';
            } else {
                provider = 'google';
            }

            getLocationFromGoogleByQuery(suggestion.city_full, provider).then(
                async (done) => {
                    let resultItems;

                    if (provider === '2gis' && !done.isBrokenAddressTwoGis) {
                        resultItems = done.result.items;
                    } else {
                        resultItems = done.results;
                    }

                    if (!resultItems) {
                        return false;
                    }

                    if (resultItems[0]) {
                        let resultItem = resultItems[0];
                        let geocodedData;

                        if (provider === '2gis' && !done.isBrokenAddressTwoGis) {
                            geocodedData = await transformTwoGisGeocodedData(resultItem);
                        } else {
                            geocodedData = await transformGoogleGeocodedData(resultItem);
                        }

                        this._saveGeoDataSuggestion(this.props.address, geocodedData);

                        this._saveReadySuggestion(this.props.address);

                        await this._fetchStaticMap();
                    }
                },
                error => {}
            );

            this._saveReadySuggestion(suggestion);
        }
    }

    _onCountryChange = (event, selectedData) => {

        var countryId = selectedData[0];

        if (this.props.onChange) {
            this.props.onChange.call(null, {
                country: selectedData[0]
            });
        }
    }

    _onInputChange = (event, data) => {
        const value = data.newValue;
        if (this.props.onChange && !this.isSuggestSelected && !this.isMapLocationSelected && !this.props.presetLocation && this.props.show) {
            // Order-588 was doing smth
            // if (value) {
            // 	this.props.onChange.call(null, {
            // 		city_full: '',
            // 		rendered_suggestion: '',
            // 	});
            // };

            this.props.onChange.call(null, {
                country: this.props.address.country || this.props.defaultCountry,
                city: value.trim() || undefined,
                text: value || undefined,
                need_calibration: true,
            });
        }
    }

    _onInputBlur = async (event) => {
        let provider;

        if (this.props.onBlur && event.target.value) {
            this.props.onBlur(event);

            let countryName = 'Россия';
            let countryField = find(countriesConfig, {id: this.props.address.country});
            if (countryField)
                countryName = countryField.name;


            if (suggestion.country_name === 'Россия') {
                provider = '2gis';
            } else {
                provider = 'google';
            }

            await getLocationFromGoogleByQuery(countryName + ' ' + this.props.address.text, provider).then(
                async (done) => {
                    let resultItems;

                    if (provider === '2gis') {
                        resultItems = done.result.items;
                    } else if (provider === 'google') {
                        resultItems = done.results;
                    }

                    if (!resultItems) {
                        return false;
                    }

                    if (resultItems[0]) {
                        let resultItem = resultItems[0];
                        let geocodedData;

                        if (provider === '2gis') {
                            geocodedData = await transformTwoGisGeocodedData(resultItem);
                        } else {
                            geocodedData = await transformGoogleGeocodedData(resultItem);
                        }

                        this._saveGeoDataSuggestion(this.props.address, geocodedData);

                        this._saveReadySuggestion(this.props.address);

                        await this._fetchStaticMap();
                    }
                },
                error => {}
            );
        }
    }

    _onMapLocationSelected = (location) => {
        this.isMapLocationSelected = true;

        if (this.props.onChange) {
            this.props.onChange.call(null, location);
        }
    }

    _suggestionsShowWhen = (input) => {
        return input.trim().length >= 0;
    }

    _onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    }

    _openMap = () => {
        this.isMapLocationSelected = false;

        this.setState({
            showMap: true,
        });
    }

    _closeMap = () => {
        this.setState({
            showMap: false,
        });
    }

    _flagOptionRenderer = (option) => {
        var ourOption = option.iso;
        if (ourOption === '' || ourOption === 'GP') {
            ourOption = 'WO';
        }
        return (
            <div>
                <FlagControl iso={ourOption}/>
                {' ' + option.label}
            </div>
        );
    }

    _flagRenderer = (option) => {
        return <FlagControl iso={option.iso}/>;
    }

    _setAddressInputRef = (inputDOMnode) => {
        this.addressInputDOMnode = inputDOMnode;
    }

    _onMapSave = () => {
        if (this.props.onMapSave) {
            this.props.onMapSave();
        }

        if (this.props.onBlur) {
            this.props.onBlur.call(null);
        }
    }

    render() {
        var { address, label, placeholder, error, countries } = this.props;

        return (

            <div className={classNames([
                "AddressControl",
                {
                    "AddressControl--error": error
                }
            ])}>

                {this.state.showMap ?
                    <GoogleWaypointMapDialog
                        countries={this.props.countries}
                        address={address}
                        onClose={this._closeMap}
                        onSelectLocation={this._onMapLocationSelected}
                        onMapSave={this._onMapSave}
                    /> : ''}
                <AnimakitExpander expanded={this.state.imgSrc !== ''} duration={200}>
                    <div className="AddressControl-staticMap">
                        <img className="AddressControl-staticMapImg" src={this.state.imgSrc}/>
                    </div>
                </AnimakitExpander>
                <div className="AddressControl-suggest">
                    <SelectControl
                        className="AddressControl-country SelectControl-container --active"
                        label="Страна"
                        options={countries}
                        value={address.country || this.props.defaultCountry}
                        optionRenderer={this._flagOptionRenderer}
                        valueRenderer={this._flagRenderer}
                        onChange={this._onCountryChange}
                    />
                    <SuggestControl
                        className="AddressControl-address"
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this._getSuggestions}
                        renderSuggestion={this._suggestionRenderer}
                        getSuggestionValue={this._suggestionValue}
                        shouldRenderSuggestions={this._suggestionsShowWhen}
                        onSuggestionsClearRequested={ this._onSuggestionsClearRequested }
                        inputProps={{
                            label,
                            placeholder,
                            error: error,
                            onChange: this._onInputChange,
                            onBlur: this._onInputBlur,
                            inputRef: this._setAddressInputRef,
                            value: address.text || '',
                        }}
                        onSuggestionSelected={this._onSuggestionSelected}
                    />

                    {
                        /*
                        <div className="AddressControl-map" onClick={this._openMap}>
                        <div className="AddressControl-mapTitle">На карте</div>
                        <div className="AddressControl-mapIcon"></div>
                        </div>
                        */
                    }
                </div>
            </div>
        );
    };
}

export default AddressControl;



// WEBPACK FOOTER //
// ./client/components/AddressControl/AddressControl.js